// eslint-disable-next-line import/prefer-default-export
export const PRODUCTION_WEB_PREFIX = 'https://12x12.press';
